import React from 'react';
import { Form, DatePicker, Row, Col, Typography } from 'antd';
import dayjs from 'dayjs';
import { SectionHeader } from '../AirwayBillDetail';

const { Text } = Typography;

const calculateTimeDiff = (endDate, startDate) => {
  if (!endDate || !startDate) return '未完成';
  
  const end = dayjs(endDate);
  const start = dayjs(startDate);
  const diffMinutes = end.diff(start, 'minute');
  
  if (diffMinutes < 0) return '时间异常';
  
  const days = Math.floor(diffMinutes / (24 * 60));
  return days > 0 ? `${days}天` : '1天';
};

const EfficiencyItem = ({ label, value }) => (
  <Col span={6} style={{ marginBottom: 6, padding: '4px 10px' }}>
    <Text strong style={{ marginRight: 8, color: '#1890ff' }}>{label}：</Text>
    <Text 
      style={{ 
        padding: '2px 8px',
        background: value === '未完成' ? '#f5f5f5' : value === '时间异常' ? '#fff1f0' : '#fff',
        borderRadius: '4px'
      }}
      type={value === '未完成' ? 'secondary' : value === '时间异常' ? 'danger' : undefined}
    >
      {value}
    </Text>
  </Col>
);

const TimeInfoSection = ({ form, airwayBillId }) => {
  // Watch each field individually for efficiency calculations
  const customs_clearance_time = Form.useWatch('customs_clearance_time', form);
  const departure_date = Form.useWatch('departure_date', form);
  const document_review_time = Form.useWatch('document_review_time', form);
  const document_send_time = Form.useWatch('document_send_time', form);
  const arrival_date = Form.useWatch('arrival_date', form);
  const airport_pickup_time = Form.useWatch('airport_pickup_time', form);
  const courier_pickup_time = Form.useWatch('courier_pickup_time', form);

  // Calculate efficiencies
  const totalEfficiency = calculateTimeDiff(
    customs_clearance_time,
    departure_date
  );
  
  const documentEfficiency = calculateTimeDiff(
    document_review_time,
    document_send_time
  );
  
  const transportEfficiency = calculateTimeDiff(
    arrival_date,
    departure_date
  );
  
  const customsEfficiency = calculateTimeDiff(
    customs_clearance_time,
    arrival_date
  );
  
  const pickupEfficiency = calculateTimeDiff(
    courier_pickup_time,
    airport_pickup_time
  );

  // Time fields are now handled by backend
  const handleTimeChange = () => {};

  return (
    <>
      <Row gutter={4} align="top" style={{ marginBottom: '8px' }}>
        <Col span={2}>
          <SectionHeader>时效信息</SectionHeader>
        </Col>
        <Col span={22}>
          <Row gutter={4}>
            <Col span={6}>
              <Form.Item name="document_send_time" label="资料发送日期">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="departure_date" label="起飞日期">
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="arrival_date" label="实际到港日期">
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="airport_pickup_time" label="机场提货日期">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={4}>
            <Col span={6}>
              <Form.Item name="document_review_time" label="审单日期">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="processing_time" label="过机日期">
                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="customs_clearance_time" label="清关放行日期">
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="courier_pickup_time" label="快递揽件日期">
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
          </Row>

          {airwayBillId && (
            <Row 
              gutter={4} 
              style={{ 
                marginTop: '2px',
                marginBottom: '16px',
                background: '#f0f7ff',
                padding: '8px',
                borderRadius: '8px',
                border: '1px solid #d6e8ff',
                boxShadow: '0 2px 4px rgba(24,144,255,0.1)'
              }}
            >
              <EfficiencyItem label="清关流程总时效" value={totalEfficiency} />
              <EfficiencyItem label="资料审核时效" value={documentEfficiency} />
              <EfficiencyItem label="运输时效" value={transportEfficiency} />
              <EfficiencyItem label="清关时效" value={customsEfficiency} />
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default TimeInfoSection;
